// lib/pack.ts — helpers for navigating flattened question lists.

import type { Pack, PackQuestion, PackSection } from '@/lib/api'

export interface FlatQuestion {
  sectionKey: string
  sectionTitle: string
  question: PackQuestion
  index: number // 0-indexed across the whole pack
}

export function flattenQuestions(pack: Pack): FlatQuestion[] {
  const out: FlatQuestion[] = []
  let idx = 0
  for (const section of pack.sections) {
    for (const question of section.questions) {
      out.push({
        sectionKey: section.key,
        sectionTitle: section.title,
        question,
        index: idx,
      })
      idx += 1
    }
  }
  return out
}

export function findQuestionIndex(
  flat: FlatQuestion[],
  sectionKey: string,
  qId: string,
): number {
  return flat.findIndex(
    (f) => f.sectionKey === sectionKey && f.question.id === qId,
  )
}

export function groupBySections(pack: Pack): PackSection[] {
  return pack.sections
}
